import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import ArrowRightAltSharpIcon from '@material-ui/icons/ArrowRightAltSharp';

import CustomButton from '../viewEventUi/CustomButton';
import Button from '@material-ui/core/Button';

function Index({
  open,
  handleClose,
  popOverContainer,
  titleText,
  contentText,
  btnOkCls,
  handleOk,
  btnOkText,
  arrowIconCls,
  cancelText,
  children,
  disableOkBtn,
}) {
  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby='form-dialog-title'
    >
      <DialogTitle id='form-dialog-title'>{titleText}</DialogTitle>
      <DialogContent>
        <div className={popOverContainer}>{children}</div>
        <DialogContentText className={popOverContainer}>
          {contentText}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        {cancelText ? (
          <Button onClick={handleClose} color='primary'>
            {cancelText}
          </Button>
        ) : null}
        <CustomButton
          btnStyle={btnOkCls}
          clickHandle={handleOk}
          btnText={btnOkText}
          disabled={!!disableOkBtn}
          endIcon={<ArrowRightAltSharpIcon className={arrowIconCls} />}
        />
      </DialogActions>
    </Dialog>
  );
}

export default Index;
